import { defineStore } from 'pinia';

import { actions } from './actions';
import { getters } from './getters';
import { defaultState } from './state';

export const useStore = defineStore('store', {
	state: defaultState,
	actions,
	getters,
});
